document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("*[data-showmore-toggle][data-show-text]")
    .forEach((button) => {
      button.addEventListener("click", () => {
        const targetAction =
          button.getAttribute("aria-expanded") === "false" ? "show" : "hide";
        const targetContainer = document.getElementById(
          button.getAttribute("data-showmore-toggle")
        );

        const targetElements = [
          ...(targetContainer.matches("*[data-showmore-item]")
            ? [targetContainer]
            : []),
          ...targetContainer.querySelectorAll("*[data-showmore-item]"),
        ];

        for (let targetElement of targetElements) {
          if (targetAction === "show") {
            targetElement.classList.remove("hidden");
          } else {
            targetElement.classList.add("hidden");
          }
        }

        button.innerText =
          targetAction === "show"
            ? button.getAttribute("data-hide-text")
            : button.getAttribute("data-show-text");
        button.setAttribute(
          "aria-expanded",
          targetAction === "show" ? "true" : "false"
        );
      });
    });
});
